export const MountainImages =[
    {
        id:1,
        url:"https://cdn.pixabay.com/photo/2020/01/16/04/52/munnar-4769654__340.jpg",
        text:"1. Munnar, Kerala",
        Info:"With its well-preserved natural beauty and sprawling tea gardens, Munnar invites honeymoon couples to spend time amidst tranquil and scenic settings. This popular hill station in Kerala also houses some romantic hotels and several activities for the newlyweds.",
        label:'see details',
        btn:'Book Now',
        path:'/mountains/1',
        
    },
    {
        id:2,
        url:"https://www.euttaranchal.com/tourism/timthumb.php?src=https://www.euttaranchal.com/tourism/photos/majkhali-8802109.jpg&w=620&q=80&h=440",
        text:"2. Ranikhet, Uttarakhand",
        label:'see details',
        btn:'Book Now',
        Info:"Built by the British, Ranikhet is a top hill station of India which you should visit to admire the beauty of topography, flora and fauna of the Himalayas.",        
        path:'/mountains/2',

    },
    {
        id:3,
        url:"https://ttg.com.bd/uploads/tours/destinations/6444447u.jpg",
        text:"3. Mirik, West Bengal",
        Info:"f you decide to visit a hill station in 2022, go for Mirik! A beautiful hill station in West Bengal, Mirik is famous for its spectacular beauty, easy accessibility and makes for a great destination for family holiday in East India.",
        label:'see details',
        btn:'Book Now',
        path:'/mountains/3',
        
    },
]